var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MainContainer',{attrs:{"hideSidebar":true}},[_c('h2',[_vm._v("Versionshinweise")]),_c('hr'),_c('Changelog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }